var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-recorder"},[(_vm.recoderStatus)?_c('div',{staticClass:"video-recorder-wapper",attrs:{"id":_vm.getId}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }